import React, { FC, useContext } from 'react'
import {
	calendarPickerClasses,
	dayPickerClasses,
	LocalizationProvider,
	pickersCalendarHeaderClasses, PickersDay,
	pickersDayClasses,
	StaticDatePicker
} from '@mui/x-date-pickers'
import { formatageDate } from '../../../utils/formatter/formatDate'
import { Box, Grid, TextField } from '@mui/material'
import { CalendrierContext } from '../context/CalendrierContext'
import { WHITE } from '../../../theme'
import { makeStyles } from 'tss-react/mui'
import styles from '../../../styles'
import { calendarOrClockPickerClasses } from '@mui/x-date-pickers/internals'
import CustomDateAdapter from './CustomDateAdapter'

const CalendarDatePicker: FC = () => {
	const {
		creneauxDisponibles,
		date,
		changeDate,
		minDate,
		maxDate
	} = useContext(CalendrierContext)

	const { classes } = useStyles()

	return (
		<Grid container item xs={12} className={classes.dateContainer}>
			<LocalizationProvider dateAdapter={CustomDateAdapter} adapterLocale='fr'>
				<StaticDatePicker
					orientation="landscape"
					openTo="day"
					value={date}
					showToolbar={false}
					onChange={(date) => {
						if (date) changeDate(date)
					}}
					displayStaticWrapperAs="desktop"
					minDate={minDate}
					maxDate={maxDate}
					shouldDisableDate={(day) => {
						if (day) {
							const dateFormatee = formatageDate(day.toString(), 'yyyy-MM-dd')
							// S'il n'y a pas de créneaux disponibles pour le jour en question, on bloque le jour
							return !(dateFormatee in creneauxDisponibles)
						}
						return true
					}}
					renderInput={(params) => <TextField {...params} />}
					renderDay={(day, _selectedDays, pickersDayProps) =>
						<Box key={day.toISOString()}>
							<PickersDay {...pickersDayProps} />
						</Box>}
					disableHighlightToday
					views={['day']}
					dayOfWeekFormatter={(day) => day}
				/>
			</LocalizationProvider>
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	dateContainer: {
		justifyContent: 'center',

		// On applique un style particulier pour l'entête du calendrier (mois & année)
		[`& .${pickersCalendarHeaderClasses.label}`]: {
			...styles(theme).text0,
			fontSize: 16,
			lineHeight: '19px',
			textTransform: 'capitalize'
		},

		// On fait en sorte que le calendrier prenne toute la longueur de la page
		'& div, & span': {
			width: '100%',
			maxWidth: '100%',
			textAlign: 'center',
			height: '100%',
			'[role=grid]': {
				display: 'flex',
				flexDirection: 'column'
			}
		},

		// On fait en sorte que le calendrier prenne toute la hauteur possible
		[`& .${calendarOrClockPickerClasses.root} > div, & .${calendarPickerClasses.root}, & .${calendarPickerClasses.viewTransitionContainer}`]: {
			maxHeight: '100%'
		},

		// Style pour la ligne des jours de la semaine
		[`& .${dayPickerClasses.header}`]: {
			height: 'auto'
		},

		// Les lignes des semaines se partagent la hauteur du mois, qu'il compte 5 ou 6 semaines
		[`& .${dayPickerClasses.monthContainer}`]: {
			display: 'flex',
			flexDirection: 'column'
		},

		// Style pour chacune des lignes des semaines
		[`& .${dayPickerClasses.weekContainer}`]: {
			height: 'auto',
			flex: 1
		},

		[`& .${pickersDayClasses.root}`]: {
			...styles(theme).text0,
			fontSize: 16,
			// On grise les dates désactivées
			'&.Mui-disabled': {
				color: '#D9D9D9'
			},
			// Style pour la date sélectionnée
			'&.Mui-selected': {
				color: WHITE
			}
		},

		// Style header calendar
		[`& .${pickersCalendarHeaderClasses.root}`]: {
			padding: 0,
			flexDirection: 'column',
			position: 'relative'
		},
		[`& .${pickersCalendarHeaderClasses.labelContainer}`]: {
			position: 'absolute',
			cursor: 'auto'
		}
	}
}))

export default CalendarDatePicker